// src/components/admin/reviews/AdminReviewsManager.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import fetchData from '../../../api/fetchData'; // Проверь путь!
import { useTranslation } from 'react-i18next';
import './AdminReviewsManager.css'; 

function AdminReviewsManager({ onContentUpdated }) {
  const { t } = useTranslation();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadReviews = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchData('/admin/reviews/admin_get_all_reviews.php', 'GET', null, { credentials: 'include' });
      if (response && response.status === 'success') {
        setReviews(response.reviews || []);
      } else {
        setError(response?.message || 'Не удалось загрузить отзывы.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReviews();
  }, []);

const handleApprove = async (reviewId) => {
    try {

        const response = await fetchData(
            '/admin/reviews/admin_approve_review.php', 
            'POST', 
            { reviewId: reviewId }, // Отправляем ID на одобрение
            { credentials: 'include' }
        );

        if (response && response.status === 'success') {
            alert(response.message); 
            loadReviews(); 

            if (onContentUpdated) {
                onContentUpdated();
            }

        } else {
            alert(t('admin.reviews.approveError', { details: response?.message || 'Unknown error' }));
        }
    } catch (err) {
        alert(t('messages.error.generic', { details: err.message }));
    }
};


const handleDelete = async (reviewId) => {
    const confirmationMessage = t('admin.reviews.deleteConfirmation', { id: reviewId });

    if (window.confirm(confirmationMessage)) {
        try {
            const response = await fetchData(
                '/admin/reviews/admin_delete_review.php', 
                'POST', 
                { reviewId: reviewId }, 
                { credentials: 'include' }
            );

            if (response && response.status === 'success') {
                alert(response.message);
                loadReviews();

                if (onContentUpdated) {
                    onContentUpdated();
                }

            } else {
                alert(t('admin.reviews.deleteError', { details: response?.message || 'Unknown error' }));
            }
        } catch (err) {
            alert(t('messages.error.generic', { details: err.message }));
        }
    }
};

  if (loading) return <p>{t('messages.loading')}</p>;
  if (error) return <p>{t('messages.error.generic', { details: error })}</p>;

  return (
    <div className="admin-reviews-manager">
      <h4>{t('admin.reviews.managerTitle', 'Управление Отзывами')}</h4>

      {reviews.length === 0 ? (
        <p>{t('admin.reviews.noItems', 'Новых отзывов нет.')}</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>{t('admin.reviews.authorLabel', 'Автор')}</th>
              <th style={{width: '40%'}}>{t('admin.reviews.messageLabel', 'Сообщение')}</th>
              <th>{t('admin.reviews.dateLabel', 'Дата')}</th>
              <th>{t('admin.reviews.statusLabel', 'Статус')}</th>
              <th>{t('admin.reviews.actionsLabel', 'Действия')}</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map(review => (
              <tr key={review.id}>
                <td>
                  <strong>{review.name}</strong>
                  <br/>
                  <small>{review.email}</small>
                </td>
                 <td>
        {review.message 
          ? review.message 
          : (
            <em> {/* Тег <em> сделает текст курсивным */}
              {t('admin.reviews.messageInOtherLang', 'Отзыв на другом языке ({{langs}})', { langs: review.available_languages.toUpperCase() })}
            </em>
          )
        }
      </td>
                <td>
                  {review.is_approved == 1
                    ? <span style={{ color: 'green', fontWeight: 'bold' }}>{t('admin.reviews.statusApproved', 'Одобрен')}</span>
                    : <span style={{ color: 'orange', fontWeight: 'bold' }}>{t('admin.reviews.statusPending', 'Ожидает')}</span>
                  }
                </td>
                <td className="admin-actions">
                  {review.is_approved == 0 && (
                    <button onClick={() => handleApprove(review.id)} className="approve-button" style={{ marginRight: '10px' }}>
                      {t('admin.buttons.approve', 'Одобрить')}
                    </button>
                  )}
                  <Link to={`/admin/reviews/edit/${review.id}`} className="edit-button" style={{ marginRight: '10px' }}>
    {t('admin.buttons.edit')}
  </Link>
                  <button onClick={() => handleDelete(review.id)} className="delete-button">
                    {t('admin.buttons.delete', 'Удалить')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminReviewsManager;